import {
  CLEAR_PERSON_ACTIONS_LOG,
  GET_ACTIONS_LOG_NAMES_SUCCESS,
  GET_ACTIONS_LOG_SUCCESS,
  GET_PERSON_ACTIONS_LOG_SUCCESS,
} from '../actionConstants';

const defaultState = {
  actionsLog: {},
  personActionsLog: {},
  count: null,
  hasUpdates: null,
  actionsLogNames: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ACTIONS_LOG_SUCCESS: {
      return {
        ...state,
        actionsLog: action.res.data,
      };
    }
    case GET_ACTIONS_LOG_NAMES_SUCCESS: {
      return {
        ...state,
        actionsLogNames: action.res,
      };
    }
    case GET_PERSON_ACTIONS_LOG_SUCCESS: {
      return {
        ...state,
        personActionsLog: action.res.data,
      };
    }
    case CLEAR_PERSON_ACTIONS_LOG: {
      return {
        ...state,
        personActionsLog: {},
      };
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default: {
      return state;
    }
  }
};
